export const PROVINCE_LABEL = 'Province';
export const CITY_LABEL = 'City/Municipality';
export const BARANGAY_LABEL = 'Barangay';
